import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DownArrowIcon } from "../../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../../assets/appearencePage/arrow-down-dark.svg";
import { ReactComponent as Brush } from "../../../../../assets/appearencePage/brush.svg";
import { ReactComponent as BrushDark } from "../../../../../assets/appearencePage/brush-dark.svg";
import { ReactComponent as Outline } from "../../../../../assets/appearencePage/outlineIcon.svg";
import { ReactComponent as OutlineDark } from "../../../../../assets/appearencePage/outlineIcon-dark.svg";

import { toast } from "react-hot-toast";

import { useDispatch, useSelector } from "react-redux";
import { createAvatarSettings } from "../../../../../redux/slices/appearance/createAvatarSettingsSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import AppearanceDeleteButton from "../../../../../components/common/buttons/AppearanceDeleteButton";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

const outLineType = ["none", "dashed", "dotted", "double", "solid"];
const outLineWidth = ["none", "1px", "2px", "4px", "8px"];
const AvatarAcc = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const [subLoading, setSubLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [color, setColor] = useColor("#561ecb");
  useEffect(() => {
    setAvatarColorHandler(color);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);
  const outLineStyleDropDownRef = useRef();
  const outLineStyleDropDownBtnRef = useRef();
  const outLineWidthDropDownRef = useRef();
  const outLineWidthDropDownBtnRef = useRef();

  const outlineColrDropDownRef = useRef();
  const outlineColrDropDownBtnRef = useRef();

  const { translate } = useLocales();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectedSize, setSelectedSize] = useState("");
  const [selectedShape, setSelectedShape] = useState("");
  const [selectedOutlineType, setSelectedOutlineType] = useState("");
  const [selectedOutlineWidth, setSelectedOutlineWidth] = useState("");

  const [outLineStlyDropdown, setOutLineStlyDropdown] = useState(false);
  const [outLineWidthDropdown, setOutLineWidthDropdown] = useState(false);

  const [colorAvatar, setColorAvatar] = useState("#CAFF");
  const [openAvatarColopicker, setOpenAvatarColopicker] = useState(false);
  const setAvatarColorHandler = (color) => {
    setColorAvatar(color.hex);
  };
  // outline style dropdown handler

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        outLineStlyDropdown &&
        outLineStyleDropDownRef.current &&
        !outLineStyleDropDownRef.current.contains(e.target) &&
        !outLineStyleDropDownBtnRef.current.contains(e.target)
      ) {
        setOutLineStlyDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outLineStlyDropdown]);

  // outline width dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        outLineWidthDropdown &&
        outLineWidthDropDownRef.current &&
        !outLineWidthDropDownRef.current.contains(e.target) &&
        !outLineWidthDropDownBtnRef.current.contains(e.target)
      ) {
        setOutLineWidthDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outLineWidthDropdown]);

  // Outline color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openAvatarColopicker &&
        outlineColrDropDownRef.current &&
        !outlineColrDropDownRef.current.contains(e.target) &&
        !outlineColrDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenAvatarColopicker(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAvatarColopicker]);

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const data = {
    linkData: linkId,
    userData: userId,
  };
  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item?.coloum_name === "avatar") {
        const value = JSON.parse(item.coloum_value);
        setSelectedSize(value.avatar_size);
        setSelectedShape(value.avatar_shape);
        setSelectedOutlineType(value?.avatar_outline?.outline_style);
        setSelectedOutlineWidth(value?.avatar_outline?.outline_width);
        setColorAvatar(value?.avatar_outline?.outline_colour || "#CAFF");
        setColor((color) => {
          return {
            ...color,
            hex: value?.avatar_outline?.outline_colour || "#CAFF",
          };
        });
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  const submitHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      userId: userId,
      linkId: linkId,
    };
    if (width > 768) {
      if (
        selectedSize &&
        selectedShape &&
        selectedOutlineType &&
        selectedOutlineWidth
      ) {
        formData.avatar_size = selectedSize;
        formData.avatar_shape = selectedShape;
        formData.avatar_outline = {
          outline_style: selectedOutlineType,
          outline_width: selectedOutlineWidth,
          outline_colour: colorAvatar,
        };
        setSubLoading(true);

        await dispatch(createAvatarSettings(formData)).then(() => {
          dispatch(gettingSettingUpdataData(user));
          dispatch(gettingSettingUpdataData(data));
          dispatch(getScreenPreviewSetting(pageName));
        });

        setSubLoading(false);
      } else {
        toast.error("Please select all fields");
      }
    } else {
      if (selectedSize && selectedShape) {
        formData.avatar_size = selectedSize;
        formData.avatar_shape = selectedShape;
        setSubLoading(true);

        await dispatch(createAvatarSettings(formData)).then(() => {
          dispatch(gettingSettingUpdataData(user));
          dispatch(getScreenPreviewSetting(pageName));
        });

        setSubLoading(false);
      } else {
        toast.error("Please select all fields");
      }
    }
  };
  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async () => {
    setDeleteStylePending(true);
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      userId: userId,
      linkId: linkId,
    };
    setSelectedSize("");
    setSelectedShape("");
    setSelectedOutlineType("");
    setSelectedOutlineWidth("");
    setColorAvatar("#CAFF");
    await dispatch(createAvatarSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(gettingSettingUpdataData(data));
      dispatch(getScreenPreviewSetting(pageName));
    });
    setDeleteStylePending(false);
  };

  return (
    <div className="mt-[30px]">
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border border-light_bg_v4 rounded-md py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small1 mb-5 dark:text-color_v1_dark">
          {/* Size */}
          {translate("size")}
        </div>
        <div className="flex gap-[20px] flex-wrap lg:gap-9 lg:justify-between items-start">
          <div
            onClick={() => setSelectedSize("75x75")}
            className={`dark:text-[#292D32] h-[55px] lg:h-[75px] w-[55px] lg:w-[75px] flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer  ${
              selectedSize === "75x75"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            75x75
          </div>
          <div
            onClick={() => setSelectedSize("100x100")}
            className={`dark:text-[#292D32] h-[80px] lg:h-[100px] w-[80px] lg:w-[100px] flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer ${
              selectedSize === "100x100"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            100x100
          </div>
          <div
            onClick={() => setSelectedSize("125x125")}
            className={`dark:text-[#292D32] h-[95px] lg:h-[125px] w-[95px] lg:w-[125px] flex justify-center items-center text-center bg-[#fcdddb] text-small3_b lg:text-small2_b cursor-pointer ${
              selectedSize === "125x125"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            125x125
          </div>
          <div
            onClick={() => setSelectedSize("150x150")}
            className={`dark:text-[#292D32] h-[115px] lg:h-[150px] w-[115px] lg:w-[150px] flex justify-center items-center text-center bg-[#fcdddb] text-small3_b lg:text-small2_b cursor-pointer ${
              selectedSize === "150x150"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            150x150
          </div>
        </div>
      </div>
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border mt-5 border-light_bg_v4 rounded-md py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small1 mb-5 dark:text-color_v1_dark">
          {/*Shape */}
          {translate("shape")}
        </div>
        <div className="flex gap-[15px] lg:gap-9 justify-start items-start">
          <div
            onClick={() => setSelectedShape("circle")}
            className={`dark:text-[#292D32] h-[70px] md:h-[55px] lg:h-[100px] w-[70px] md:w-[55px] lg:w-[100px] rounded-full flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer  ${
              selectedShape === "circle"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            {/* Circle */}
            {translate("cms.circle")}
          </div>
          <div
            onClick={() => setSelectedShape("rounded")}
            className={`dark:text-[#292D32] h-[70px] md:h-[55px] lg:h-[100px] w-[70px] md:w-[55px] lg:w-[100px] rounded-lg flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer ${
              selectedShape === "rounded"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            {/* Rounded */}
            {translate("rounded")} <br /> {/*corners */}
            {translate("cms.corners")}
          </div>
          <div
            onClick={() => setSelectedShape("straight")}
            className={`dark:text-[#292D32] h-[70px] md:h-[55px] lg:h-[100px] w-[70px] md:w-[55px] lg:w-[100px] flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer ${
              selectedShape === "straight"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            {/* Straight */}
            {translate("straight")}
            <br />
            {/*corners */}
            {translate("cms.corners")}
          </div>
        </div>
      </div>
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border mt-5 border-light_bg_v4 rounded-md py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small1 mb-5 dark:text-color_v1_dark">
          {/* Outline */}
          {translate("cms.outline")}
        </div>
        <div className="relative">
          <div
            ref={outLineStyleDropDownBtnRef}
            onClick={() => setOutLineStlyDropdown(!outLineStlyDropdown)}
            className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040]"
          >
            <div className="flex justify-center items-center">
              {darkMode ? <OutlineDark /> : <Outline />}
            </div>
            <div className="w-full capitalize bg-transparent text-small2 lg:text-small1 dark:text-color_v1_dark">
              {selectedOutlineType
                ? selectedOutlineType
                : translate("cms.outline_style")}
            </div>
            <div className=" flex justify-center items-center">
              {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
            </div>
          </div>
          {outLineStlyDropdown && (
            <div
              ref={outLineStyleDropDownRef}
              className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-36 overflow-y-auto"
            >
              {outLineType.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setSelectedOutlineType(item);
                      setOutLineStlyDropdown(false);
                    }}
                    className="px-[10] lg:px-[15px] py-[7px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md"
                  >
                    <div
                      style={{ borderStyle: item }}
                      className={`w-full capitalize ${
                        item === "solid"
                          ? "border-2"
                          : item === "double"
                          ? "border-double border-4"
                          : "border-2 border-" + item
                      } border-heading_color dark:border-color_v2_dark p-1 lg:p-2 py-0.5 lg:py-1`}
                    >
                      {item}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="relative">
          <div
            ref={outLineWidthDropDownBtnRef}
            onClick={() => setOutLineWidthDropdown(!outLineWidthDropdown)}
            className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040] mt-2.5"
          >
            <div className="flex justify-center items-center">
              {darkMode ? <BrushDark /> : <Brush />}
            </div>
            <div className="w-full capitalize bg-transparent text-small2 lg:text-small1 dark:text-color_v2_dark">
              {selectedOutlineWidth
                ? selectedOutlineWidth
                : translate("cms.outline_width")}
            </div>
            <div className=" flex justify-center items-center">
              {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
            </div>
          </div>
          {outLineWidthDropdown && (
            <div
              ref={outLineWidthDropDownRef}
              className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-20 overflow-y-auto"
            >
              {outLineWidth.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setSelectedOutlineWidth(item);
                      setOutLineWidthDropdown(false);
                    }}
                    className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v2_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md"
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="relative flex items-center justify-start w-full mt-5">
          <div
            ref={outlineColrDropDownBtnRef}
            onClick={() => setOpenAvatarColopicker(!openAvatarColopicker)}
            style={{
              background: colorAvatar,
            }}
            className={`rounded-md me-[16px] border lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] `}
          ></div>

          {openAvatarColopicker && (
            <div
              className="absolute top-0 lg:w-[80%] 2xl:w-[60%] w-full pb-5 "
              style={{ zIndex: "999999999" }}
            >
              <div
                ref={outlineColrDropDownRef}
                className="border shadow-xl bg-white rounded-lg p-3"
              >
                <ColorPicker
                  color={color}
                  onChange={setColor}
                  hideInput={true}
                  height={150}
                />
                <div className="flex flex-wrap justify-center items-center -mt-[8px] gap-2 px-2">
                  <div className="flex justify-center items-center gap-1 w-full">
                    <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                      <p>HEX</p>
                    </div>
                    <p>:</p>
                    <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                      <p>{color.hex}</p>
                    </div>
                  </div>
                  <div className="flex gap-1 justify-between w-full ">
                    <div className="border rounded-md px-1 py-0.5 text-small1">
                      {Math.round((color.rgb.a / 1) * 100)}%
                    </div>
                    <button
                      className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                      onClick={() => setOpenAvatarColopicker(false)}
                    >
                      DONE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="w-full overflow-hidden">
            <div className="text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
              {/* Color */}
              {translate("color")}
            </div>
            <div className="text-small2_b text-heading_color ">
              <input
                value={colorAvatar}
                type="text"
                className="focus:outline-none -mt-[8px] dark:bg-dark-secondary dark:text-color_v1_dark"
                onChange={(e) => {
                  setColor((color) => {
                    return { ...color, hex: e.target.value };
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex mt-[25px] items-center justify-end">
        <AppearanceDeleteButton
          isLoading={deleteStylePending}
          onClickHandler={deleteHandler}
        />

        <ExtraSmallFilledButton
          name={`${translate("biolink_title.save_cap")}`}
          buttonType={"button"}
          isLoading={subLoading}
          onClickHandler={submitHandler}
          classes={"ms-3"}
        />
      </div>
    </div>
  );
};

export default AvatarAcc;
